import { FeatureDTO } from "./FeatureDTO";

export class CheckoutFeatureDTO extends FeatureDTO {
    constructor(sub?) {
        super(sub);
    }
}
